/**
 * Where is this bundle actually running?
 *
 * The POS ships one build to two places: a desk browser and the Capacitor
 * Android shell (`webDir: '../dist'`). Screens must be able to say which,
 * because printing, the cash drawer and NFC only exist in one of them — and a
 * control that silently does nothing is worse than one that says why.
 */

interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
}

function capacitor(): CapacitorGlobal | undefined {
  if (typeof window === 'undefined') return undefined;
  return (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor;
}

/** True only inside the Android shell, never in a desk browser or a PWA tab. */
export function isNativeShell(): boolean {
  try {
    return capacitor()?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

/** "Android" / "iOS" / "Browser" — for the About screen. */
export function platformLabel(): string {
  try {
    const platform = capacitor()?.getPlatform?.();
    if (platform === 'android') return 'Android';
    if (platform === 'ios') return 'iOS';
  } catch {
    // fall through
  }
  return 'Browser';
}
